import { Stack } from '@mui/material';
import { GridPagination } from '@mui/x-data-grid';
import { getTotalSum } from 'core/utils/productUtils';
import { observer } from 'mobx-react-lite';
import { useContext, useMemo } from 'react';
import StoreContext from 'stores/context/StoreContext';
import Total from './Total';
import * as projectUtils from './orderProjectUtils';
import type { ProjectProduct } from 'models/order/orderProject';
import type { FC } from 'react';

const ProductsGridFooter: FC<ProductsGridFooterProps> = observer(({ products }) => {
  const { userStore } = useContext(StoreContext);

  const totalSum = useMemo(() => getTotalSum(products ?? []), [products]);
  const markup = projectUtils.getTotalMarkupForUser(
    products,
    userStore.userData?.id ?? 0
  );

  return (
    <Stack
      direction={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}
      px={1}
      sx={{ borderColor: (theme) => theme.palette.divider }}
      borderTop={1}>
      <Total totalSum={totalSum} markup={markup} />
      <GridPagination />
    </Stack>
  );
});

interface ProductsGridFooterProps {
  products: ProjectProduct[];
}

export default ProductsGridFooter;
